import React, {useState, useEffect} from 'react'
import PubSub from 'services/PubSub/'
import Drawer from 'components/Drawers/Drawer'
import {actionsType} from 'config/constants'
import AddressSelection from './AddressSelection'
import style from './style.scss'

let actions = []

const DrawerAddressSelection = () => {
    const [payload, setPayload] = useState(null)

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.ADDRESS_OPEN, _openModalDrawerAddress))

        return function cleanup() {
            actions = actions.map((token) => PubSub.unregister(token))
            actions = []
        }
    }, [])

    const _openModalDrawerAddress = (payload) => {
        setPayload(payload)
    }

    return (
        <Drawer
            customClass={'drawer-address-selection'}
            actionOpen={actionsType.DRAWER.ADDRESS_OPEN}
            actionClose={actionsType.DRAWER.ADDRESS_CLOSE}>
            <AddressSelection payload={payload} />
        </Drawer>
    )
}

export default DrawerAddressSelection
